var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D'int\xE9r\xEAt g\xE9n\xE9ral") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(0.166667, 0.166667)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94352754,29.7768609 C9.33422833,29.3861601 9.86413231,29.1666667 10.4166667,29.1666667 L35.4166667,29.1666667 C36.5672599,29.1666667 37.5,28.2339266 37.5,27.0833333 L37.5,6.25 C37.5,5.09940677 36.5672599,4.16666667 35.4166667,4.16666667 L6.25,4.16666667 C5.09940677,4.16666667 4.16666667,5.09940677 4.16666667,6.25 L4.16666667,34.5537217 L8.94352754,29.7768609 Z M11.2796116,33.3333333 L3.55647246,41.0564725 C2.24404567,42.3688993 0,41.4393851 0,39.5833333 L0,6.25 C0,2.79822031 2.79822031,0 6.25,0 L35.4166667,0 C38.8684464,0 41.6666667,2.79822031 41.6666667,6.25 L41.6666667,27.0833333 C41.6666667,30.535113 38.8684464,33.3333333 35.4166667,33.3333333 L11.2796116,33.3333333 Z",
    id: "path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.5e7033f953aa799fd31443071a944673.svg";
export { ForwardRef as ReactComponent };